import { render, staticRenderFns } from "./updateStudentInfo.vue?vue&type=template&id=cc046aea&"
import script from "./updateStudentInfo.vue?vue&type=script&lang=js&"
export * from "./updateStudentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc046aea')) {
      api.createRecord('cc046aea', component.options)
    } else {
      api.reload('cc046aea', component.options)
    }
    module.hot.accept("./updateStudentInfo.vue?vue&type=template&id=cc046aea&", function () {
      api.rerender('cc046aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/updateStudentInfo.vue"
export default component.exports